import React from "react";

type ContentBlock = {
    type?: string;
    text?: string;
    file_name?: string;
};

type ChatMessage = {
    role?: string;
    content?: unknown;
};

function describeUserBlock(block: ContentBlock): string {
    if (block.type === "image") {
        return "[Görsel]";
    }
    if (block.type === "pdf") {
        return block.file_name ? `[PDF: ${block.file_name}]` : "[PDF]";
    }
    if (block.type === "youtube") {
        return "[YouTube]";
    }
    return block.text?.trim() ? block.text : "";
}

function describeAssistant(content: unknown): string {
    if (!content || typeof content !== "object") {
        return "";
    }
    const data = content as {
        chat_title?: string;
        blocks?: Array<{ type?: string; content?: unknown; title?: string }>;
    };
    const parts: string[] = [];
    if (data.chat_title) {
        parts.push(data.chat_title);
    }
    for (const block of data.blocks ?? []) {
        const body = typeof block.content === "string"
            ? block.content
            : block.content != null
                ? JSON.stringify(block.content)
                : "";
        const line = [block.title, body].filter(Boolean).join(": ");
        if (line) {
            parts.push(line);
        }
    }
    return parts.join("\n");
}

function describeMessage(message: ChatMessage): string {
    const role = message.role === "assistant" ? "Asistan" : "Kullanıcı";
    if (Array.isArray(message.content)) {
        const body = message.content
            .map((item) => describeUserBlock(item as ContentBlock))
            .filter(Boolean)
            .join(" ");
        return `${role}: ${body || "–"}`;
    }
    return `${role}: ${describeAssistant(message.content) || "–"}`;
}

/**
 * Sohbet mesajlarını metin + medya etiketi olarak gösterir; görsel/PDF dosyası yok.
 */
export function ChatContentPreview({ value }: { value?: unknown }) {
    if (!Array.isArray(value) || value.length === 0) {
        return <span>–</span>;
    }
    return (
        <div className="flex flex-col gap-1 whitespace-pre-wrap text-sm">
            {value.map((item, index) => (
                <div key={index}>{describeMessage(item as ChatMessage)}</div>
            ))}
        </div>
    );
}
